import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { IQuestion } from 'pages/task/types';

interface SelectYearProps {
  value: string;
  childQuestion: boolean;
  question: IQuestion;
  setAnswer: (key: string, childQuestion?: boolean) => void;
}

const SelectYear: React.FC<SelectYearProps> = ({
  value,
  childQuestion,
  question,
  setAnswer,
}) => {
  const inputValue = Array.isArray(value) ? value.join(', ') : value || '';

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setAnswer(event.target.value, childQuestion);
  };

  const years = Array.from({ length: 100 }, (_, index) =>
    (2024 - index).toString()
  );

  return (
    <Select
      data-testid="select-year-option-component"
      onChange={handleSelectChange}
      value={inputValue}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      sx={{ mb: 3 }}
    >
      <MenuItem disabled value="">
        {question.placeholder}
      </MenuItem>
      {years.map((year) => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectYear;
